import { connect } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next"
import { toast } from "react-toastify";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
    Col,
    Row,
    Label
} from "reactstrap";
import EntityRoutingService from "src/modules/3rd-party-management/apis/admin/EntityRoutingService";

const DeleteRoutingModal = ({
    t,
    toggle,
    show,
    onComplete,
    routingSettings
}) => {
    const entityService = EntityRoutingService.getInstance();

    const restoreSettingsMutation = useMutation({
        mutationFn: async () => {
            return await entityService.restoreRouterSettings(routingSettings?.legal_entity?.id);
        },
        onError: () => {
            toast(t("An error occurred while restoring settings."), {
                type: "error"
            });
        },
        onSuccess: () => {
            toast(t("Settings restored successfully."), {
                type: "success",
            });
            toggle();
            onComplete();
        }
    });

    return (
        <Modal 
            size="md" 
            isOpen={show}
        >
            <ModalHeader 
                className="border-0" 
                toggle={toggle}
            >
                {t("Delete Routing Settings")}
            </ModalHeader>

            <ModalBody>
                <Row className="mb-2">
                    <Col sm='12' className="mb-1">
                        <Label>    
                            {t("Entity")}
                        </Label>
                        <p>
                            {routingSettings?.legal_entity?.title}
                        </p>
                    </Col>

                    <Col sm='12' className="mb-1">
                        <Label>    
                            {t("Default Owner")}
                        </Label>
                        <p>
                            {routingSettings?.default_supplier_owner?.full_name}
                        </p>
                    </Col>

                    <Col sm='12' className="mb-1">
                        <Label>    
                            {t("Assign Risks To")}
                        </Label>
                        <p>
                            {routingSettings?.default_supplier_risk_owner?.full_name}
                        </p>
                    </Col>

                    <Col sm='12'>
                        <Label>    
                            {t("Assign Tasks To")}
                        </Label>
                        <p>
                            {routingSettings?.default_supplier_task_owner?.full_name}
                        </p>
                    </Col>
                </Row>
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="danger" 
                    onClick={toggle} 
                    disabled={false}
                >
                    {t('Cancel')}
                </Button>

                <Button 
                    color="primary" 
                    onClick={restoreSettingsMutation.mutate}
                    disabled={restoreSettingsMutation.isLoading}
                >
                    {
                        restoreSettingsMutation.isLoading && (
                            <Spinner 
                                animation="border" 
                                variant="primary" 
                                size="sm" 
                                className="me-1"
                            />
                        )
                    }
                    {t('Delete Routing')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

const mapStatetoProps = (state) => {
    const { user: currentUser } = state.Login;
    return {
        currentUser
    };
};

export default withNamespaces()(
    connect(mapStatetoProps)(
        DeleteRoutingModal
    )
);